import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import { DarkVenueHeatmapConfigState } from './DarkVenueHeatmapConfigState';
import { selectDarkVenueHeatmapWidgetState } from '../selectors';

export const buildDarkVenueHeatmapWidgetConfigSlice = () =>
    buildConfigSlice<DarkVenueHeatmapConfigState>(
        WidgetType.DARK_VENUE_HEATMAP,
        selectDarkVenueHeatmapWidgetState,
        {}
    );

export const useDarkVenueHeatmapWidgetConfigSlice = () =>
    useConfigSlice(buildDarkVenueHeatmapWidgetConfigSlice());

export type DarkVenueHeatmapConfigPayloadType =
    WidgetConfigSliceActionPayloadType<DarkVenueHeatmapConfigState>;
